import { render, staticRenderFns } from "./UpdateExercises.vue?vue&type=template&id=24259758&scoped=true&"
import script from "./UpdateExercises.vue?vue&type=script&lang=js&"
export * from "./UpdateExercises.vue?vue&type=script&lang=js&"
import style0 from "./UpdateExercises.vue?vue&type=style&index=0&lang=css&"
import style1 from "./UpdateExercises.vue?vue&type=style&index=1&id=24259758&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24259758",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
